export const accentTertiaryLight1 = '#aa74be' //hsl(284, 36%, 60%)
export const accentTertiaryLight2 = '#bf97ce' //hsl(284, 36%, 70%)
export const accentTertiaryLight3 = '#f4eef7' //hsl(284, 36%, 95%)
export const accentTertiaryLight4 = '#fbf8fc' //hsl(284, 36%, 98%)
